import type { PageNumber, PdfiumAPI } from "@pdfking/pdfium"
import type {
  PDFReaderOptions,
  PDFSplitFunction,
  PDFSplitResult,
} from "@pdfking/renderer-api"
import type { MediaPixel } from "../types/MediaPixel"
import { BlobArray } from "@pdfking/compatibility"
import { Provision } from "@pdfking/pdfium"
import { AutoThrow } from "../utils/AutoThrow"
import { OpenReader } from "../utils/OpenReader"
import { PageRange } from "../utils/PageRange"

async function* PDFSplitImpl(
  api: PdfiumAPI,
  input: PDFReaderOptions,
  rangeFn?: (page_count: number) => Iterable<number>
): AsyncGenerator<PDFSplitResult> {
  const { handle, page_count, ensure_page, close } = await OpenReader(
    api,
    input.stream,
    input.size
  )

  try {
    for (const page of PageRange(page_count, rangeFn)) {
      const pageIndex = (page - 1) as PageNumber
      await ensure_page(pageIndex)
      const { bytes, media } = AutoThrow(
        await api.split_page(handle, pageIndex)
      )
      yield {
        blob: BlobArray(bytes, "application/pdf"),
        ...(media as MediaPixel),
      }
    }
  } finally {
    await close()
  }
}

export const PDFSplit: PDFSplitFunction = (input, rangeFn) =>
  Provision(api => PDFSplitImpl(api, input, rangeFn))
